

import { useState, useEffect } from "react";
import { collection, query, onSnapshot, orderBy } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFirebaseServices } from "@/lib/firebase/client";
import { EarningsChart } from "./EarningsChart";

interface InstallEvent {
  timestamp?: any;
  cpi: number;
  eventCount: number;
  date: string;
}

export function DashboardEarningsChart() {
  const [events, setEvents] = useState<InstallEvent[]>([]);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const userId = auth.currentUser?.uid;

  useEffect(() => {
    if (!userId) {
      setLoading(false);
      return;
    }

    const services = getFirebaseServices();
    if (!services) {
      setLoading(false);
      return;
    }

    const { db } = services;
    const eventsRef = collection(db, `users/${userId}/installEvents`);
    
    // Fetch all events ordered by timestamp (no limit to ensure accurate totals)
    const q = query(eventsRef, orderBy('timestamp', 'desc'));

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const fetchedEvents = snapshot.docs.map(doc => doc.data()) as InstallEvent[];

      setEvents(fetchedEvents);
      setLoading(false);
    }, (error) => {
      console.error('Error fetching dashboard events:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [userId]);

  if (loading) {
    return (
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <div className="flex items-center justify-center py-12">
          <p className="text-sm text-white/50">Loading timeline...</p>
        </div>
      </div>
    );
  }

  if (events.length === 0) {
    return (
      <div className="rounded-2xl border border-white/10 bg-white/5 p-4">
        <h3 className="mb-2 text-lg font-semibold">Analytics Timeline</h3>
        <div className="flex items-center justify-center py-12">
          <p className="text-sm text-white/50">No install events yet</p>
        </div>
      </div>
    );
  }

  return <EarningsChart events={events} />;
}
